<div class="dialog-container">
  <div flex layout-align="space-between center" layout="row">
    @if (identityFixed) {
      <div
        class="modal-dialog-title"
        [translate]="'clients.blacklistDialogTitle'"
        [translateParams]="{
          type: valueLabelKey | translate,
          value: blacklistEditData?.value,
        }"
        flex
      >
        Block in blacklist
      </div>
    } @else {
      <div class="modal-dialog-title" [translate]="'clients.newBlacklist'" flex>
        Add in blacklist
      </div>
    }
    <button tabindex="-1" mat-icon-button (click)="onNoClick()">
      <mat-icon>clear</mat-icon>
    </button>
  </div>
  <hr />
  <form
    [itfgPermissions]="'BLACKLIST_WRITE'"
    layout="column"
    novalidate
    [formGroup]="blacklistEditForm"
    (ngSubmit)="onSubmit($event)"
  >
    @if (!identityFixed) {
      <div flex="100" layout="column">
        <mat-form-field flex="100">
          <mat-select
            required
            matInput
            formControlName="blacklistType"
            (selectionChange)="selectedValueChanged()"
            placeholder="{{ 'clients.chooseType' | translate }}"
          >
            @for (blacklistType of blacklistTypes; track blacklistType) {
              <mat-option
                [disabled]="['BLACKLIST_WRITE'] | isUnauthorized | async"
                [value]="blacklistType.id"
                >{{ blacklistType.name }}</mat-option
              >
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field flex="100">
          <mat-label>{{
            gridSecondColumnTranslations[selectedBlacklistType] | translate
          }}</mat-label>
          <textarea
            matInput
            required
            formControlName="value"
            class="bulk-values-textarea"
            placeholder="{{
              gridSecondColumnTranslations[selectedBlacklistType] | translate
            }}"
            (paste)="bulkAddPaste($event)"
            cdkTextareaAutosize
            cdkAutosizeMinRows="6"
            cdkAutosizeMaxRows="15"
          >
          </textarea>
          @if (blacklistFormArr.hasError('required')) {
            <mat-error [translate]="'forms.required'">required</mat-error>
          }
          @if (invalidValues && blacklistFormArr.invalid) {
            <mat-hint [ngStyle]="{ color: '#d32f2f' }"
              >{{ 'clients.blacklistImportInvalid' | translate
              }}{{ invalidValues }}</mat-hint
            >
          }
        </mat-form-field>

        @if (existingValuesWarnings.length > 0) {
          <div class="existing-values-warning">
            @for (warning of existingValuesWarnings; track warning.value) {
              <div
                class="existing-value-row"
                layout="row"
                layout-align="start center"
              >
                <span
                  [translate]="'clients.blacklistValueAlreadyExists'"
                  [translateParams]="{
                    type: valueLabelKey | translate,
                    value: warning.value,
                  }"
                >
                  Value already blacklisted
                </span>
                @for (brand of warning.brands; track $index; let last = $last) {
                  <img
                    class="warning-brand-logo"
                    [src]="brand.logo"
                    [alt]="brand.name"
                  />
                  <span>{{ brand.name }}{{ last ? '' : ',' }}</span>
                }
              </div>
            }
          </div>
        }
      </div>
    }

    @if (isLoading) {
      <div class="progress-spinner-container">
        <mat-spinner
          class="progress-spinner"
          strokeWidth="10"
          [diameter]="150"
        ></mat-spinner>
      </div>
    } @else {
    <mat-checkbox [formControl]="allBrandsControl" class="all-brands-checkbox">
      <span>{{ 'brands.allBrands' | translate }}</span>
    </mat-checkbox>

    <div class="brand-rows">
      @if (allBrandsControl.value) {
        <div
          class="brand-row"
          layout="row"
          layout-align="start center"
          [formGroup]="globalRowForm"
        >
          <img
            class="all-brands-logo"
            src="assets/images/itf.png"
            [matTooltip]="'brands.allBrands' | translate"
            matTooltipPosition="above"
            alt="ITF logo"
          />
          <mat-form-field flex="60" class="brand-row-field" subscriptSizing="dynamic">
            <mat-label>{{ 'clients.notes' | translate }}</mat-label>
            <input
              matInput
              type="text"
              formControlName="notes"
              itfgOverflowTooltip
              matTooltip
              [tooltipText]="globalRowForm.get('notes').value"
              [tooltipPosition]="'above'"
            />
          </mat-form-field>
          <mat-form-field flex="40" class="brand-row-field" subscriptSizing="dynamic">
            <mat-label>{{ 'clients.expire' | translate }}</mat-label>
            <input
              matInput
              formControlName="expire"
              [matDatepicker]="globalPicker"
              [min]="currentDate"
            />
            <div matSuffix layout="row" layout-align="center center">
              <itfg-form-control-clear
                [control]="globalRowForm.get('expire')"
              ></itfg-form-control-clear>
              <mat-datepicker-toggle [for]="globalPicker"></mat-datepicker-toggle>
            </div>
            <mat-datepicker [touchUi]="isMobile()" #globalPicker></mat-datepicker>
          </mat-form-field>
        </div>
      } @else {
        @for (brand of brands; track brand.id; let i = $index) {
          <div
            class="brand-row"
            layout="row"
            layout-align="start center"
            [formGroup]="brandRowAt(i)"
          >
            <mat-checkbox formControlName="checked"></mat-checkbox>
            <itfg-brand-logo [brand]="brand" size="24px"></itfg-brand-logo>
            <mat-form-field flex="60" class="brand-row-field" subscriptSizing="dynamic">
              <mat-label>{{ 'clients.notes' | translate }}</mat-label>
              <input
                matInput
                type="text"
                formControlName="notes"
                itfgOverflowTooltip
                matTooltip
                [tooltipText]="brandRowAt(i).get('notes').value"
                [tooltipPosition]="'above'"
              />
            </mat-form-field>
            <mat-form-field flex="40" class="brand-row-field" subscriptSizing="dynamic">
              <mat-label>{{ 'clients.expire' | translate }}</mat-label>
              <input
                matInput
                formControlName="expire"
                [matDatepicker]="rowPicker"
                [min]="currentDate"
              />
              <div matSuffix layout="row" layout-align="center center">
                <itfg-form-control-clear
                  [control]="brandRowAt(i).get('expire')"
                ></itfg-form-control-clear>
                <mat-datepicker-toggle [for]="rowPicker"></mat-datepicker-toggle>
              </div>
              <mat-datepicker [touchUi]="isMobile()" #rowPicker></mat-datepicker>
            </mat-form-field>
          </div>
        }
      }
    </div>
    }

    <div
      class="dialog-bottom-nav-bar"
      flex="100"
      layout="row"
      layout-align="end center"
    >
      <button
        mat-raised-button
        color="primary"
        type="submit"
        [disabled]="isSaving || existingValuesWarnings.length > 0"
      >
        @if (isSaving) {
          <mat-spinner diameter="20"></mat-spinner>
        } @else {
          <span>{{ 'global.save' | translate }}</span>
        }
      </button>
    </div>
  </form>
</div>

